// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A `Quay` is the **place to board or alight a concrete vehicle by passengers**, aka **passenger-platform** for **train (de:Gleis)**, or **bus stand (de:Kante)** or **ship pier (de:Steg)**, related to a `ServiceProduct::vehicleMode`.
 * @export
 * @interface Quay
 */
export interface Quay {
    /**
     * Non-formal id provided by J-S, see `swissLocationId`.
     * @type {string}
     * @memberof Quay
     */
    id?: string;
    /**
     * Quay SLOID, if known (within Switzerland), related to `name`.Swiss location id (SLOID) from Atlas. More on [Service Points (Atlas) API](https://developer.sbb.ch/apis/atlas/documentation) > GET /service-point-directory/v1/service-points. Depending on the context of the response, it might be an SLOID of the Quay itself or its departure/arrival track or even a section of a track.
     * @type {string}
     * @memberof Quay
     */
    swissLocationId?: string;
    /**
     * Quay name as displayed at a `StopPlace`, therefore special case like '12/13' is possible if decided dynamically at arrival or departure of the vehicle.
     * @type {string}
     * @memberof Quay
     */
    name: string;
    /**
     * Id of the parent `Quay` (aka Transmodel `ZONE` or `STOP PLACE COMPONENT`), if any, modelling subzone / superzone relation. Useful to determine if 2 quays are on the same physical platform. Use it only for comparison, not for display, and not on long term comparison (may change over time). Only given for `StopPlaceDetailed`.
     * @type {string}
     * @memberof Quay
     */
    parentId?: string;
}

/**
 * Check if a given object implements the Quay interface.
 */
export function instanceOfQuay(value: object): value is Quay {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function QuayFromJSON(json: any): Quay {
    return QuayFromJSONTyped(json, false);
}

export function QuayFromJSONTyped(json: any, ignoreDiscriminator: boolean): Quay {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'swissLocationId': json['swissLocationId'] == null ? undefined : json['swissLocationId'],
        'name': json['name'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
    };
}

  export function QuayToJSON(json: any): Quay {
      return QuayToJSONTyped(json, false);
  }

  export function QuayToJSONTyped(value?: Quay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'swissLocationId': value['swissLocationId'],
        'name': value['name'],
        'parentId': value['parentId'],
    };
}

